<!-- Se comenta el POP-UP de informacion de mantenimiento 
 <app-popup-information></app-popup-information> -->
<router-outlet> </router-outlet>
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-spin-clockwise-fade" [fullScreen] = "true"></ngx-spinner>
